import { get } from '../../../../../assets/js/shared/data-manager';
import Vue from '../../../../../assets/vendor/vue/dist/vue';
import FunctionalCalendar from '../../../../../assets/vendor/vue-functional-calendar/dist/FunctionalCalendar.umd';
import moment from 'moment/min/moment-with-locales';
import EventCalendarCategoriesPanel from './event-calendar-categories-panel';

export default class EventCalendar {
    constructor($element) {
        this.$element = $element;
        this.dateMax = this.$element.querySelector('[data-event-calendar]').dataset.eventCalendarDateMax;

        this.dateStart = this.$element.querySelector('[data-event-calendar]').dataset.eventCalendarStart;
        this.dataSourcePath = this.$element.querySelector('[data-event-calendar]').dataset.eventCalendarDataSource;
        this.fetchEventPath = this.$element.querySelector('[data-fetch-event-path]')?.dataset.fetchEventPath;
        this.numberOfMonths = parseInt(this.$element.querySelector('[data-event-calendar]').dataset.eventCalendarNumberOfMonths);
        this.filterDefaultNumberOfTicketsMin = this.$element.querySelector('[data-event-calendar]').dataset.filterDefaultNumberOfTicketsMin;
        this.categories = this.$element.querySelector('[data-event-calendar]').dataset.eventCalendarCategories;
        this.skipCategoryPanel = this.$element.querySelector('[data-event-calendar]').dataset.eventCalendarSkipCategoryPanel;
        this.ShowOnlyMonthsWidthTickets = this.$element.querySelector('[data-event-calendar]').dataset.eventCalendarShowOnlyMonthsWidthTickets;
        this.componentId = this.$element.dataset.componentId;

        this.createVueApp();
    }

    createVueApp() {
        const componentId = this.componentId;
        const dataSourcePath = this.dataSourcePath;
        const fetchEventPath = this.fetchEventPath;
        const ShowOnlyMonthsWidthTickets = this.ShowOnlyMonthsWidthTickets;
        const categoryPanelVisible = this.skipCategoryPanel ? false : true;
        const filterDefaultNumberOfTicketsMin = this.filterDefaultNumberOfTicketsMin;
        const dateStart = this.dateStart;
        const numberOfMonths = this.numberOfMonths;
        const dateMax = this.dateMax;
        const categories = JSON.parse(this.categories);

        new Vue({
            el: this.$element,
            delimiters: ['v{','}v','@{','}'],
            components: {
                FunctionalCalendar,
                EventCalendarCategoriesPanel
            },
            data: () => {
                return {
                    filters: {
                        start: '01-' + dateStart,
                        numberOfTickets: filterDefaultNumberOfTicketsMin,
                        numberOfParkingTickets: null,
                        seatRankId: null,
                        salesChannelId: null,
                        priceTypeId: null,
                        ticketmaticWidgetSalesChannelId: null,
                        ticketmaticWidgetPromocode: null,
                        ticketWinnerCode: null,
                    },
                    categories: categories,
                    previousWindowWidth: null,
                    loading: false,
                    nextMonth: null,
                    dateMax: dateMax,
                    categoryPanelVisible: categoryPanelVisible,
                    ShowOnlyMonthsWidthTickets: ShowOnlyMonthsWidthTickets,
                    events: [],
                    nextEvent: [],
                    prevEvent: [],
                    fetchEventPath: fetchEventPath ? fetchEventPath : `${placeholders.baseUri}/ajax/${componentId}/${dataSourcePath}`,
                    firstEvent: false,
                    disableEventCalendarToggle: true,
                    calendarData: {},
                    calendarConfigs: {
                        hiddenElements: ['navigationArrows'],
                        dateFormat: 'dd-mm-yyyy',
                        showTimePicker: false,
                        isDatePicker: false,
                        isDateRange:true,
                        isMultiple: true,
                        isDark: true,
                        calendarsCount: numberOfMonths,
                        changeMonthStep: numberOfMonths,
                        dayNames: ['MA', 'DI', 'WO', 'DO', 'VR', 'ZA', 'ZO'],
                        monthNames: ["januari","februari","maart","april","mei","juni","juli","augustus","september","oktober","november","december"]
                    }
                }
            },
            computed: {
                categoryTitle() {
                    if ( ! this.filters.seatRankId) {
                        return null
                    }

                    return this.categories.find(categorie => categorie.seatRankId === this.filters.seatRankId).title.nl;
                },
                disableNextArrow() {
                    return moment(this.nextMonth, 'MM-YYYY').isSameOrAfter(moment(this.dateMax, 'MM-YYYY'));
                },
            },
            watch: {
                'filters.start': {
                    handler() {
                        this.fetchEvents();
                    }
                },
                'filters.numberOfTickets': {
                    handler() {
                        this.fetchEvents();
                    }
                },
                'filters.seatRankId': {
                    handler() {
                        this.fetchEvents();
                    }
                },
            },
            methods: {
                async fetchEvents() {
                    this.setLoading(true);

                    // If supported parameters have been passed to the current page
                    // through the request, we'll pass them along to the AJAX endpoint
                    const requestParams = (new URL(window.location)).searchParams;
                    let t;

                    t = requestParams.get('salesChannelId');
                    if (t) {
                        this.filters.salesChannelId = t;
                    }

                    t = requestParams.get('priceTypeId');
                    if (t) {
                        this.filters.priceTypeId = t;
                    }

                    t = requestParams.get('ticketmaticWidgetSalesChannelId');
                    if (t) {
                        this.filters.ticketmaticWidgetSalesChannelId = t;
                    }

                    t = requestParams.get('ticketmaticWidgetPromocode');
                    if (t) {
                        this.filters.ticketmaticWidgetPromocode = t;
                    }

                    t = requestParams.get('numberOfTickets');
                    if (t) {
                        this.filters.numberOfTickets = t;
                    }

                    t = requestParams.get('numberOfParkingTickets');
                    if (t) {
                        this.filters.numberOfParkingTickets = t;
                    }

                    t = requestParams.get('ticketWinnerCode');
                    if (t) {
                        this.filters.ticketWinnerCode = t;
                    }

                    if (this.filters.start) {
                        this.filters.end = moment(this.filters.start, 'DD-MM-YYYY')
                                .add(this.calendarConfigs.calendarsCount, 'M')
                                .subtract(1, 'd')
                                .locale('nl')
                                .format('DD-MM-YYYY');
                    }

                    const result = await get(this.fetchEventPath, this.filters);
                    this.events = result.data;
                    this.nextEvent = result.nextEvent;
                    this.prevEvent = result.prevEvent;

                    this.setLoading(false);
                    if(this.filters.start) {
                        this.setCalendarStartDate(this.filters.start)
                    }

                    if(Object.keys(this.events).length && !this.filters.start) {
                        this.setCalendarStartDate(Object.values(this.events)[0][0].date.date);
                    }
                },
                changedMonth(e) {
                    this.nextMonth = moment(e).add(this.calendarConfigs.calendarsCount, 'M').format('MM-YYYY');
                    this.filters.start = moment(e).locale('nl').format('DD-MM-YYYY');
                },
                getMonthFormatted(day) {
                    return moment(day.date,'D-MM-YYYY').locale('nl').format('MMM');
                },

                getNextEventMonthFormatted() {
                    return this.nextEvent && this.nextEvent.date ? moment(this.nextEvent.date.date,'D-MM-YYYY').locale('nl').format('MMMM') : null;
                },
                getPrevEventMonthFormatted() {
                    return this.prevEvent && this.prevEvent.date ? moment(this.prevEvent.date.date,'D-MM-YYYY').locale('nl').format('MMMM') : null;
                },
                getEventsForDay(day, data) {
                    const date = moment(day.date,'D-MM-YYYY').locale('nl').format('DD-MM-YYYY');
                    return this.events[date];
                },
                toggleCategoryPanel() {
                    this.categoryPanelVisible = !this.categoryPanelVisible;
                },
                closeCategoryPanel() {
                    this.categoryPanelVisible = false;
                },
                setCategoryTitle(title) {
                    this.categoryTitle = title;
                },
                setCalendarStartDate(date) {
                    const currentDate = moment(this.calendarData.currentDate).locale('nl').format('DD-MM-YYYY');

                    if(this.$refs.calendar && currentDate !== date) {
                        this.$refs.calendar.ChooseDate(date);
                    }
                },
                goToMonth(date) {
                    this.$refs.calendar.ChooseDate(date.date)
                    this.changedMonth(moment(date.date, 'DD-MM-YYYY').utc());
                },
                windowResized() {
                    if(this.previousWindowWidth === window.innerWidth) {
                        return;
                    }

                    this.previousWindowWidth = window.innerWidth;

                    if(window.innerWidth < 992) {
                        this.calendarConfigs.calendarsCount = 1;
                        this.calendarConfigs.changeMonthStep = 1;
                        if(this.$refs.calendar) {
                            this.$refs.calendar.setConfigs();
                            this.$refs.calendar.initCalendar();
                            this.fetchEvents();
                        }
                    } else {
                        this.calendarConfigs.calendarsCount = numberOfMonths;
                        this.calendarConfigs.changeMonthStep = numberOfMonths;
                        if(this.$refs.calendar) {
                            this.$refs.calendar.setConfigs();
                            this.$refs.calendar.initCalendar();
                            this.fetchEvents();
                        }
                    }
                },
                /**
                 * Go to the next month width events
                 */
                goToNextMonthWidthEvents() {
                    if (this.nextEvent && this.nextEvent.date) {
                        const date = moment(this.nextEvent.date.date,'D-MM-YYYY')
                                .locale('nl')
                                .startOf('month')
                                .format('DD-MM-YYYY');

                        this.$refs.calendar.ChooseDate(date);
                        this.changedMonth(this.$refs.calendar.calendar.currentDate);
                    }
                },
                /**
                 * Go to the prev month width events
                 */
                goToPrevMonthWidthEvents() {
                    if (this.prevEvent && this.prevEvent.date) {
                        const date = moment(this.prevEvent.date.date,'D-MM-YYYY')
                                .locale('nl')
                                // If we show 2 calendars we fill up both calendars width events also showing the month before the last event
                                .subtract(this.calendarConfigs.calendarsCount - 1, 'months')
                                .startOf('month')
                                .format('DD-MM-YYYY');

                        this.$refs.calendar.ChooseDate(date);
                        this.changedMonth(this.$refs.calendar.calendar.currentDate);
                    }
                },
                setLoading(flag) {
                    this.loading = flag;
                }
            },
            created() {
                this.fetchEvents();
                this.windowResized();

                this.nextMonth = moment(dateStart, 'MM-YYYY').add(this.calendarConfigs.calendarsCount, 'M').format('MM-YYYY');

                window.addEventListener('resize', this.windowResized);
            }
        });
    }
}